import { motion } from "framer-motion";
import { useRef, useLayoutEffect, useState } from "react";
import { FrozenDrop } from "./RainEndPhase";

interface VortexProps {
  frozenDrops: FrozenDrop[];
}

export function Vortex({ frozenDrops }: VortexProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerSize, setContainerSize] = useState({ w: 0, h: 0 });

  useLayoutEffect(() => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setContainerSize({ w: rect.width, h: rect.height });
    }
  }, []);

  return (
    <div ref={containerRef} className="absolute inset-0">
      {frozenDrops.map((drop) => {
        const startX =
          (drop.x / 100) * containerSize.w - containerSize.w / 2;
        const startY =
          (drop.y / 100) * containerSize.h - containerSize.h / 2;

        return (
          <motion.div
            key={drop.id}
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              width: 40,
              height: 40,
              marginLeft: -20,
              marginTop: -20,
            }}
            initial={{
              x: startX,
              y: startY,
              rotate: 0,
              scale: 1,
              opacity: 1,
            }}
            animate={{
              x: 0,
              y: 0,
              rotate: 720,
              scale: 0,
              opacity: 0,
            }}
            transition={{
              duration: 0.8,
              ease: "easeIn",
            }}
          >
            <img
              src="/espont.png"
              alt="espont"
              className="w-full h-full object-contain drop-shadow-lg"
              style={{ filter: "blur(0.5px)" }}
            />
          </motion.div>
        );
      })}
    </div>
  );
}
